<template>
    <div style="width: 100%" v-loading.fullscreen.loc="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="clearfix"></div>
        <el-row :gutter="20" class="mlr-1">
            <el-col :sm="24" :md="24">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" label-width="120px"
                    class="demo-ruleForm">
                    <el-row :gutter="10">
                        <el-col :sm="24" :md="20" :lg="20">
                            <el-form-item label="Host Name" prop="hostName">
                                <el-input v-model="ruleForm.hostName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" :md="4" :lg="4">
                            <el-form-item label="Port NO." prop="port">
                                <el-input v-model="ruleForm.port"></el-input>
                            </el-form-item>

                        </el-col>
                        <el-col :sm="24" :md="12" :lg="12">
                            <el-form-item label="User Name" prop="userName">
                                <el-input v-model="ruleForm.userName"></el-input>
                            </el-form-item>

                        </el-col>
                        <el-col :sm="24" :md="12" :lg="12">
                            <el-form-item label="Password" prop="password">
                                <el-input v-model="ruleForm.password"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="12">
                            <el-form-item label="Reply Email" prop="replyEmail">
                                <el-input v-model="ruleForm.replyEmail"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-form-item>
          <el-checkbox v-model="ruleForm.isDefault">Make it default payment system</el-checkbox>
        </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">Integrate</el-button>
                        <el-button @click="resetForm('ruleForm')">Reset</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div class="clearfix"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Add_SMTP_Details",
    components: {},
    data() {
        return {
            loading: false,
            loadingText: 'Loading ......!',
            ruleForm: {
                hostName: '',
                userName: "",
                password: "",
                port: 587,
                replyEmail: '',
                type: 'SMTP'

            },
            rules: {
                hostName: [{ required: true, message: 'Please enter Host details', trigger: 'blur' },],
                userName: [
                    { required: true, message: 'Please enter user name', trigger: 'blur' },
                    // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'Please enter password', trigger: 'blur' },
                    // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
                ],
                port: [
                    { required: true, message: 'Please enter port number', trigger: 'blur' },
                    // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
                ],
                replyEmail: [
                    { required: true, message: 'Please enter valid email', trigger: 'blur' }
                ]
            }
        };
    },
    computed: {
        ...mapGetters("paymentGateway", ["getPlansData", "getActivePaymentSystems", "getPaymentGatewayInfo", "getUpdateSystemInfo"]),
        ...mapGetters("auth", ["getActiveWorkspace", "getAuthenticatedUser"]),
        ...mapGetters("customConfiguration", ["getSmtpConfiguration", "getSmtpStatus", "getError"])
    },
    created() { },
    mounted() {
    },
    methods: {
        //validation Methods start 
        validateSMTPHostName(hostName) {
            let regex = new RegExp(/^(?!-)[A-Za-z0-9-]+([-.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/); // Regular expression pattern to validate SMTP host name
            return regex.test(hostName);// Test if the host name matches the pattern
        },
        validatePortNumber(port) {
            var portNumber = parseInt(port, 10);// Convert port to a number
            return !isNaN(portNumber) && portNumber >= 1 && portNumber <= 65535; // Check if portNumber is a number and within the valid range
        },
        validateEmail(email) {
            // Regular expression pattern for basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },

        async validateSendGridAPIKey(apiKey) {

            const apiKeyRegex = /^[A-Za-z0-9_-]+$/; // Basic format check
            if (!apiKeyRegex.test(apiKey)) {
                return false; // Invalid format
            }

            // Additional checks (optional): Authenticate with SendGrid API
            const url = 'https://api.sendgrid.com/v3/scopes';
            const headers = {
                'Authorization': `Bearer ${apiKey}`
            };

            try {
                const response = await fetch(url, { headers });
                if (!response.ok) {
                    return false; // Invalid API key
                }

                const data = await response.json();
                // Check if the response contains expected data for authentication
                if (data && data.scopes) {
                    return true; // Valid API key
                } else {
                    return false; // Invalid API key
                }
            } catch (error) {
                console.error('Error validating SendGrid API key:', error);
                return false; // Error occurred during validation
            }
        },

        // validation methods end
        async getSMTPDetails() {
            this.loading = true;
            this.loadingText = "Fetching SMTP Details";
            // await this.$store.dispatch("paymentGateway/fetchActivePaymentSystems");
            console.log("active systems", this.getActivePaymentSystems);
            this.loadingText = "Loading ......!";
            this.loading = false;
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                this.loading = true;
                this.loadingText = "Verifying your form details ....!"
                if (valid) {
                    this.loading = true;
                    this.loadingText = "Please wait ..... Host is validating....";
                    //Validate The field values start
                    let hostValidation = this.validateSMTPHostName(this.ruleForm.hostName);
                    if (!hostValidation ) {
                        this.loading = false;
                        this.loadingText = "Loading ......!";
                        this.$notify.error({
                            title: 'Error',
                            message: 'Invalid Host Details'
                        });
                        return;
                    }
                    
                    this.loadingText = "Please wait ..... Port is validating....";
                    let portValidation = this.validatePortNumber(this.ruleForm.port);
                    if (!portValidation) {
                        this.loading = false;
                        this.loadingText = "Loading ......!";
                        this.$notify.error({
                            title: 'Error',
                            message: 'Invalid Port Details '
                        });
                        return;
                    }

                    this.loadingText = "Please wait ..... Email is validating....";
                    let emailValidate = this.validateEmail(this.ruleForm.replyEmail);

                    
                    if (!emailValidate ) {
                        this.loading = false;
                        this.loadingText = "Loading ......!";
                        this.$notify.error({
                            title: 'Error',
                            message: 'Invalid Email Details '
                        });
                        return;
                    }
                    

                    // validate the field values here end
                    this.loadingText = "Establishing secure  e-e encryption process ..... ";
                    const smtpData = this.$CryptoJS.AES.encrypt(JSON.stringify(this.ruleForm), this.getActiveWorkspace.company_id).toString();
                    this.loadingText = "Please wait ..... Validating your  details.";
                    await this.$store.dispatch("customConfiguration/addSMTP", { info: smtpData, type: this.ruleForm.type });
                    if (this.getError && this.getError.message ) {
                        this.$notify({
                            title: "Error",
                            message: this.getError.message,
                            type: "error",
                        });
                        this.loading = false;

this.loadingText = "Loading ......!";
                    }
                    else{
                        this.$notify({
                            title: "Success",
                            message: `SMTP details integrated.`,
                            type: "success",
                        });
                        // this.$router.push({ path: "/profilesettings/paymentIntegrationList" })
                        this.ruleForm = {
                            hostName: '',
                            userName: "",
                            password: "",
                            port: 587,
                            replyEmail: '',
                            type: 'SMTP'
                        }
                        this.$emit("success");
                        this.loading = false;

                        this.loadingText = "Loading ......!";
                    }


                } else {
                    console.log('error submit!!');
                    this.loading = false;
                    this.loadingText = "Loading ....!"
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }


    }

};
</script>

<style lang="scss" scoped>
.mlr-1 {
    margin: 0 1rem !important;
}

.clearfix {
    padding-bottom: 2rem;
}


.el-card__body {
    padding: 1rem !important;
}
</style>